module.exports = __webpack_public_path__ + "static/media/machixBrand.d030dce3.png";